// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"371":"9023c767","431":"0d6ef05b","557":"d9e2d648","738":"dec1ce39"}[chunkId] + ".css";
};